class schedule {
  constructor(scheduleId, name) {
    this.scheduleId = scheduleId;
    this.name = name;
  }
  static fromJson({ HorarioId, Nombre }) {
    return new schedule(HorarioId, Nombre);
  }
}
export default schedule;
